import React from 'react';

export function LiveViewPanel({ isOpen, onClose, selectedTariffs }) {
  const totalMonthly = selectedTariffs.reduce((sum, tariff) => sum + (Number(tariff.price) || 0), 0);
  const totalYearly = totalMonthly * 12;
  const total24Months = totalMonthly * 24;

  const totalSavings = selectedTariffs.reduce((sum, tariff) => {
    const current = Number(tariff.price) || 0;
    const original = Number(tariff.promoPrice) || Number(tariff.originalPrice) || current;
    return sum + (original > current ? (original - current) : 0);
  }, 0);

  const handlePrint = () => {
    const ids = selectedTariffs.map((tariff) => tariff.id).join(',');
    window.open(`druckansicht.html?tarife=${ids}`, '_blank');
  };

  return (
    <>
      <div
        className={`live-view-overlay ${isOpen ? 'visible' : ''}`}
        style={{ position: 'fixed', inset: 0, zIndex: 150, background: 'rgba(0,0,0,0.6)', opacity: isOpen ? 1 : 0, pointerEvents: isOpen ? 'auto' : 'none', transition: 'opacity 0.3s' }}
        onClick={onClose}
      />

      <div className={`live-view-panel ${isOpen ? 'visible' : ''}`} style={{ position: 'fixed', top: 0, right: 0, width: '100%', maxWidth: 440, height: '100%', zIndex: 151, transform: isOpen ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 0.35s cubic-bezier(0.4,0,0.2,1)' }}>
        <div className="live-view-inner">
          <div className="live-view-header">
            <div className="live-view-title">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <path d="M3 9h18" />
                <path d="M9 21V9" />
              </svg>
              <span>Tarif-Vergleich</span>
            </div>
            <button className="live-view-close" onClick={onClose}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="live-view-content">
            {selectedTariffs.map((tariff) => {
              const price = Number(tariff.price) || 0;
              const originalPrice = Number(tariff.promoPrice) || Number(tariff.originalPrice) || price;
              const savings = originalPrice > price ? (originalPrice - price) : 0;
              const isPrepaid = tariff.segment === 'prepaid';

              return (
                <div key={tariff.id} className="live-view-tariff">
                  <div className="live-view-tariff-header">
                    <span className="live-view-tariff-name">{tariff.title}</span>
                    <span className="live-view-tariff-data">{tariff.dataLabel}</span>
                  </div>
                  <div className="live-view-tariff-grid">
                    <div className="live-view-stat">
                      <div className="live-view-stat-label">Monat</div>
                      <div className="live-view-stat-value">{price.toFixed(2).replace('.', ',')} €</div>
                    </div>
                    <div className="live-view-stat">
                      <div className="live-view-stat-label">{isPrepaid ? '4 Wochen' : '24 Monate'}</div>
                      <div className="live-view-stat-value">{(price * (isPrepaid ? 1 : 24)).toFixed(2).replace('.', ',')} €</div>
                    </div>
                    {savings > 0 && (
                      <>
                        <div className="live-view-stat">
                          <div className="live-view-stat-label">Ersparnis/Mon</div>
                          <div className="live-view-stat-value savings">-{savings.toFixed(2).replace('.', ',')} €</div>
                        </div>
                        <div className="live-view-stat">
                          <div className="live-view-stat-label">Effektivpreis</div>
                          <div className="live-view-stat-value">{(price - savings).toFixed(2).replace('.', ',')} €</div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}

            {selectedTariffs.length > 1 && (
              <div className="live-view-summary">
                <div className="live-view-summary-title">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2v20M2 12h20" />
                  </svg>
                  <span>Zusammenfassung</span>
                </div>
                <div className="live-view-summary-grid">
                  <div className="live-view-summary-stat">
                    <div className="live-view-summary-label">Gesamt/Monat</div>
                    <div className="live-view-summary-value total">{totalMonthly.toFixed(2).replace('.', ',')} €</div>
                  </div>
                  <div className="live-view-summary-stat">
                    <div className="live-view-summary-label">Gesamt/Jahr</div>
                    <div className="live-view-summary-value">{totalYearly.toFixed(2).replace('.', ',')} €</div>
                  </div>
                  <div className="live-view-summary-stat">
                    <div className="live-view-summary-label">24 Monate</div>
                    <div className="live-view-summary-value">{total24Months.toFixed(2).replace('.', ',')} €</div>
                  </div>
                  {totalSavings > 0 && (
                    <div className="live-view-summary-stat">
                      <div className="live-view-summary-label">Ersparnis gesamt</div>
                      <div className="live-view-summary-value savings">-{(totalSavings * 24).toFixed(2).replace('.', ',')} €</div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="live-view-footer">
            <button className="live-view-print-btn" onClick={handlePrint}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 9V2h12v7" />
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                <rect x="6" y="14" width="12" height="8" />
              </svg>
              <span>Druckansicht öffnen</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
